import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

//common way to create private route
const PaymentRequestRoute = ({ children, ...rest /*using rest parameter*/ }) => {
    const authState = useSelector((state) => state.auth);
    return authState.user &&
        ((authState.user.account && authState.user.account && authState.user.account.isBankMisrCredentials) ||
            authState.user.role == 'root') ? (
        children
    ) : (
        <Navigate to={`/`} />
    );
};

export default PaymentRequestRoute;
